import * as Storage from './storage';

export const isAuthenticated = () => null !== Storage.get('uid');
